import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setDrawerOpened } from './drawerActions';
import Drawer from './Drawer';

function DrawerContainer(props) {
    return (
        <div>
            <Drawer
                drawerOpened={props.drawerOpened}
                setDrawerOpened={props.setDrawerOpened}
                mortgageType={props.mortgageType}
                applicantsIncome={props.applicantsIncome}
                requestedLoanAmount={props.requestedLoanAmount}
                requestedTimeSpan={props.requestedTimeSpan}
                estaminatedPropertyValue={props.estaminatedPropertyValue}
                estaminatedPropertyMonthlyRent={props.estaminatedPropertyMonthlyRent}
                steps={props.steps}
                applicant={props.applicant}
                user={props.user}
                maxLendAmount={props.maxLendAmount}
                decision={props.decision}
            />
        </div>
    );
}

const mapStateToProps = state => ({
    drawerOpened: state.drawerReducer.drawerOpened,
    steps: state.formStepperReducer.steps,
    // applicants and loan details
    applicantsIncome: state.quickQuoteReducer.applicantsIncome,
    mortgageType: state.quickQuoteReducer.mortgageType,
    requestedLoanAmount: state.quickQuoteReducer.requestedLoanAmount,
    estaminatedPropertyValue: state.quickQuoteReducer.property.estaminatedPropertyValue,
    estaminatedPropertyMonthlyRent: state.quickQuoteReducer.property.estaminatedPropertyMonthlyRent,
    requestedTimeSpan: state.quickQuoteReducer.requestedTimeSpan,
    // applicant data
    applicant: state.applicantDetailsReducer.applicant,
    user: state.registerReducer.user,
    maxLendAmount: state.softCheckReducer.maxLendAmount,
    decision: state.softCheckReducer.decision,
});

const mapDispatchToProps = dispatch => ({
    setDrawerOpened: (drawerOpened) => {
        dispatch(setDrawerOpened(drawerOpened));
    },
});

DrawerContainer.propTypes = {
    drawerOpened: PropTypes.bool.isRequired,
    setDrawerOpened: PropTypes.func.isRequired,
    steps: PropTypes.array.isRequired,
    mortgageType: PropTypes.string.isRequired,
    applicantsIncome: PropTypes.array.isRequired,
    requestedLoanAmount: PropTypes.object.isRequired,
    requestedTimeSpan: PropTypes.number.isRequired,
    estaminatedPropertyValue: PropTypes.object.isRequired,
    estaminatedPropertyMonthlyRent: PropTypes.object.isRequired,
    applicant: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    maxLendAmount: PropTypes.object.isRequired,
    decision: PropTypes.string.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DrawerContainer);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/DrawerContainer.js